import { apiProvider } from './api';
import { router } from './router';

export const ZakaznikCDB = {
	apiProvider,
	router,
};
